import { ComedianLite, SuggestedComedianType } from "@/data/comedians";

import { LivestreamAndToken } from "@/data/livestreaming";
import { ShowInfo } from "@/data/shows";
import {
  Special,
  SpecialWithComedian,
  SpecialWithUnlocked,
} from "@/data/specials";

export enum FeedPostType {
  SPECIAL = "special",
  COMEDIAN = "comedian",
  NEARBY_SHOWS = "nearby_shows",
  SUGGESTED_SPECIAL = "suggested-special",
  SUGGESTED_COMEDIANS_CAROUSEL = "suggested-comedians-carousel",
  CONTINUE_WATCHING_CAROUSEL = "continue-watching-carousel",
  TRENDING_SPECIALS_CAROUSEL = "trending-specials-carousel",
}

export type FeedPost = {
  id: string;
  score: number;
  date: string;
  type: FeedPostType;
  userFollowsComedian?: boolean;
  special?: Special;
  livestream?: LivestreamAndToken | null;
  comedian?: SuggestedComedianType;
  trendingSpecials?: SpecialWithUnlocked[];
};

export interface FeedDataResult {
  feedPosts: FeedPost[];
  suggestedComedians: any[];
  filteredComedianDictionary: Record<string, SuggestedComedianType>;
  shorts?: SpecialWithComedian[];
}

export interface ComedianLiteWithImageUrl extends ComedianLite {
  imageUrl?: string;
}

export interface ShowsObject extends Omit<ShowInfo, "datetime"> {}

export interface FeedAdCampaignData {
  comedianDisplayName: string | null;
  comedianPageUrl: string;
  locationName: string;
  shows: ShowsObject[];
}

export interface Short extends SpecialWithComedian {}
